const DateRangesMs = {
    DAY: (1000 * 60 * 60 * 24),
    WEEK: ((1000 * 60 * 60 * 24) * 7),
    MONTH: ((1000 * 60 * 60 * 24) * 31),
    YEAR: ((1000 * 60 * 60 * 24) * 365)
};

export default DateRangesMs;
